import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const driversReducer = foxGridReducer(gridNames.drivers);

export default driversReducer;
